import { hhoRpc } from "./rpcSender";

const customerApiPrefix: string = "";
const getFullUrl = (pathUrl: string) => [customerApiPrefix, pathUrl].join("");

/**
 * Base Response
 */
export interface IResponse<T> {
  data: T;
  success: boolean;
  errorCode?: number | string;
  errorMessage?: string;
  notSuccess?: boolean;
}

interface IApplyDownloadAppRequest {
  feature?: string;
  source?: string;
}

/**
 * 申请邀请码
 * @param
 * @returns
 */
export const applyDownloadApp = (
  payload: IApplyDownloadAppRequest
): Promise<IResponse<string>> => {
  return hhoRpc({
    method: "post",
    headers: {},
    payload: payload || {},
    url: getFullUrl("/user/openapi/applyDownloadApp"),
  });
};
